import { Inject, Injectable } from "@angular/core";
import { IgenomicsState } from "@ispm/core/interfaces/genomics-state.interface";
import { IWorkflowJobItem } from "@ispm/workflow/interfaces/job-item.interface";
import { select, Store } from '@ngrx/store';
import { shareReplay } from 'rxjs/operators';
import { Observable } from "rxjs";
import { IWorkflow } from '@ispm/core/interfaces/workflow.interface';
import { IRevision } from '@ispm/dashboard/test/interfaces/diagnostic-order.interface';
import { selectUiConfiguration } from '../../../app/configuration/store/configuration.selector';
import { AuthenticationService } from "@ispm/user/services/authentication.service";

@Injectable()
export class PathwayConfirmStepService {
    private cloneResourcesName = 'cloneResources';
    private practitionerFieldName = 'practitioner';
    private performerFieldName = 'performer';
    private workflowActionFieldName = 'workflowAction';
    private TestFieldName = 'Test';
    private workflowStepActionOverride$: Observable<any>;

    constructor(private authService: AuthenticationService,
        private store: Store<IgenomicsState>) {

        this.workflowStepActionOverride$ = this.store.pipe(
            select(selectUiConfiguration(null, this.TestFieldName, this.workflowActionFieldName)),
            shareReplay(1));
    }

    public getStepActiveJobItem(currentWorkflow: IWorkflow, currentRevision: IRevision): IWorkflowJobItem {
        if (!currentRevision?.items) {
            return null;
        }

        const revision = currentRevision.items.find(val => val.id === currentWorkflow.activeJob);
        return currentWorkflow.activeJobPurpose !== this.cloneResourcesName ? revision : currentRevision.items[0];
    }

    public checkIfUserCanPerformStep(currentWorkflow: IWorkflow): boolean {
        return currentWorkflow?.references.some(ref => {
            if (ref?.key.toLowerCase() === this.practitionerFieldName && ref?.value != null) {
                try {
                    const val = JSON.parse(ref.value);
                    let isPerformer = val?.practType === this.performerFieldName
                                    && val.practId === this.authService.user.info.id;

                    return isPerformer;
                } catch (e) {
                    console.error(`Could not parse workflow reference with value: ${ref.value}, error: ${e}`);
                }
            }

            return false;
        });
    }

    public getWorkflowStepActionOverride(): Observable<any> {
        return this.workflowStepActionOverride$;
    }
}